function myTest() {
  log("Welcome to custom js")
  alert("Welcome to custom js");
}

$(function () {
  // alert("Hello, custom js");
});
